import React, { useEffect } from 'react'
import './App.css';
import Home from './Home';
import Header from './Header';
import Checkout from './Checkout'
import Login from './Login';
import { Route,Routes } from "react-router-dom";
import { auth } from './Firebase';
import { useStateValue } from './StateProvider';

function App() {
  const[{},dispatch]=useStateValue();
  useEffect(()=>{
    auth.onAuthStateChanged(authUser =>{
      console.log('The User is =>',authUser)
      if(authUser){
        dispatch({
          type:'SET_USER',
          user:authUser
        })
      }
      else{
        dispatch({
          type:'SET_USER',
          user:null
        })
      }
    })
  },[])
  return (
    <div className='app'>
      
      <Routes>  
    <Route path="/" element={<>
      <Header /> <Home /> </>} />
    <Route path="/checkout" element={<><Header /><Checkout /> </>} />
    <Route path='/login' element={<Login />} />
    {/* <Route path='*' element={<Errorpage />}/> */}
</Routes>
    </div>
  );
}

export default App;
